import { trigger, transition, style, animate } from '@angular/animations';

export const popInAndOut = trigger(
  'popInAndOut',
  [
    transition(
      ':enter',
      [
        style({ bottom: '-150px' }),
        animate('1s ease-out',
          style({ bottom: '0' })),
      ],
    ),
    transition(
      ':leave',
      [
        style({ bottom: 0 }),
        animate('.7s ease-in',
          style({ bottom: '-150px' })),
      ],
    ),

  ],
);
